<template>
  <div
    class="el-form-item asterisk-right el-form-item--label-top flex items-center"
    :class="{
      'is-required': required
    }"
  >
    <label :for="titleFor" class="el-form-item__label truncate mb-0 shrink">
      <slot>{{ title }}</slot>
    </label>

    <th-popover v-if="info || $slots.info" :text="info" class="ml-2">
      <slot name="info" />
    </th-popover>
  </div>
</template>

<script>
// @DEPRECATED
// Please use the <ElFormItemDescriptive /> component instead.
export default {
  name: 'ThInputTitle',

  props: {
    title: {
      type: String,
      required: false,
      default: undefined
    },
    info: {
      type: String,
      required: false,
      default: undefined
    },
    titleFor: {
      type: String,
      required: false,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/*
  Margin/Padding added here for backwards compatibility so that they can be overridden
  by tailwind classes
 */
.el-form-item {
  @apply pb-2 mb-0;
  --el-form-label-font-size: var(--el-font-size-base);
}
</style>
